const ProfileNotifications = {
  components: {
    'term-search': TermSearch,
  },
  mixins: [ProfileValidation],
  computed: {
    ...Vuex.mapState(['signup', 'profile']),
    alertsLimitReached() {
      return this.profile.alerts
        ? this.profile.alerts.length >= this.limit
        : false;
    },
  },
  data() {
    return {
      limit: 10,
      regional: false,
    };
  },
  methods: {
    addRegion(region) {
      if (!region) return;
      const idx = this.profile.alerts.map((a) => a._id).indexOf(region._id);
      if (idx >= 0) {
        return;
      }
      this.profile.alerts.push(region);
    },
    removeRegion(region) {
      if (!region) return;
      const idx = this.profile.alerts.map((a) => a._id).indexOf(region._id);
      if (idx < 0) {
        return;
      }
      this.profile.alerts.splice(idx, 1);
    },
    finish() {
      this.$parent.$emit('save.profile');
      customAlert(
        'Datos guardados con éxito',
        'Tu perfil no está completo, por favor revisa tus datos para que este sea público y puedas apuntarte a las ofertas de empleo.',
      ).then(() => {
        document.location = '/usuarios/panel/#/perfil/informacion';
      });
    },
  },
  template: `
    <div>

      <div v-if="signup">
        <h3>Notificaciones</h3>
        <label>
          <input
            type="checkbox"
            class="uk-checkbox"
            v-model="profile.notify"
          />
          <template v-if="profile.type === 'P'">
            Recibir notificaciones de nuevas ofertas de empleo relacionadas con mi perfil.
          </template>
          <template v-if="profile.type === 'E'">
            Recibir notificaciones de presupuestos y ofertas de trabajo relacionadas con mi perfil.
          </template>
        </label>
      </div>

      <h3>Localizaciones</h3>
      <p
        class="uk-alert uk-alert-danger"
        v-if="$v.profile.alerts.$invalid"
      >
        Debes rellenar este campo para poder publicar tu perfil
      </p>
      <div class="uk-margin-medium-top">
        <p>
          Indica hasta 10 localizaciones en las que prestas tus servicios para aparecer en el directorio y recibir notificaciones. 
          <br>
          Puedes escoger entre localidades o provincias completas.
        </p>
        <div class="uk-grid">
          <div class="uk-width-1-2@m uk-margin-top">
            <term-search
              placeholder="¿Dónde?" checkbox="true"
              v-model="regional" taxonomy="regional"
              @input="addRegion(regional)"
              :disabled="alertsLimitReached"
            ></term-search>
            <div v-if="alertsLimitReached">
              <div class="uk-alert uk-alert-warning uk-margin-top">
                Has llegado al límite de notificaciones
              </div>
            </div>
          </div>
          <div class="uk-width-1-2@m uk-margin-top">
            <ul class="uk-list">
              <li v-for="(region, idx) in profile.alerts">
                <label>
                  {{ region.title }}
                  <span @click="removeRegion(region)" class="x-remove --black"></span>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="uk-text-right uk-margin-large-top uk-margin-large-bottom">
        <button v-if="!signup" @click="$parent.$emit('profile.save');" class="uk-button uk-button-dmtk">Guardar</button>
        <button v-if="signup" @click="finish()" class="uk-button uk-button-primary uk-button-bold">
          Finalizar
        </button>
      </div>

    </div>
  `,
};
